function removeWebSafe(safeEncodedString) {
  return safeEncodedString.replace(/-/g, '+').replace(/_/g, '/')
}

function makeWebSafe(encodedString) {
  return encodedString.replace(/\+/g, '-').replace(/\//g, '_')
}

function decodeBase64Hash(code) {
  return Uint8Array.from(atob(code), c => c.charCodeAt(0))
}

async function encodeBase64Hash(key, data) {
  const encoder = new TextEncoder()
  const keyData = key
  const algorithm = { name: 'HMAC', hash: 'SHA-1' }

  const cryptoKey = await crypto.subtle.importKey(
    'raw',
    keyData,
    algorithm,
    false,
    ['sign']
  )

  const signature = await crypto.subtle.sign(
    'HMAC',
    cryptoKey,
    encoder.encode(data)
  )

  return btoa(String.fromCharCode(...new Uint8Array(signature)))
}

async function signUrl(path, secret) {
  const uri = new URL(path)
  const safeSecret = decodeBase64Hash(removeWebSafe(secret))
  const hashedSignature = makeWebSafe(await encodeBase64Hash(safeSecret, uri.pathname + uri.search))
  return `${uri.toString()}&signature=${hashedSignature}`
}

export { removeWebSafe, makeWebSafe, decodeBase64Hash, encodeBase64Hash, signUrl }
